import { EnumProductTypeQuery, EnumContentType, EnumContentTypeText, EnumProductUnit } from '@xt/client/enums/product'
import type { CourseCardUIType } from '@xt/client/entities/my-v2/types.d'
import type { CourseItem, CourseType, MyCourseList } from '@xt/client/types/my-go-course'
import { AjaxBasics } from '@xt/client'
import moment from 'moment'

// 格式化数字, 返回数字及缩进单位
export function formatMomentCountUnit(count: number): {
  num: number
  unit: string
} {
  if (!count || typeof count !== 'number' || count < 0)
    return {
      num: 0,
      unit: ''
    }

  if (count > 0 && count <= 999) {
    return {
      num: count,
      unit: ''
    }
  } else if (count > 999 && count <= 9999) {
    return {
      num: Math.round(count / 1000),
      unit: 'K'
    }
  } else {
    return {
      num: Math.round(count / 10000),
      unit: 'W'
    }
  }
}

// 格式化日期，返回年月日
export function formatYearMonthDay(time: number) {
  const [y, m, d] = moment(time)
    .format('YYYY-MM-DD')
    .split('-')
    .map(v => parseInt(v))

  return {
    y,
    m,
    d
  }
}

export function transfromProductList(myProductList: MyCourseList) {
  let result: Array<CourseItem & CourseCardUIType> = []
  const courseTypeMap = {
    courseResultVOS: EnumProductTypeQuery.Course,
    activityResultVOS: EnumProductTypeQuery.DayCourse,
    showResultVOS: EnumProductTypeQuery.Exhibition,
    selfStudyResultVOS: EnumProductTypeQuery.SelfStudy,
    specialCourseResults: EnumProductTypeQuery.SpecialCourse,
    remedialShowResults: EnumProductTypeQuery.Exhibition
  }

  if (!myProductList) return []

  Object.entries(courseTypeMap).forEach(([fieldName, value]) => {
    if (Array.isArray(myProductList[fieldName])) {
      myProductList[fieldName].forEach((course: CourseItem) => {
        result.push(transformItem(course, value as CourseType))
      })
    }
  })

  return result.sort((a, b) => b.successTime - a.successTime)
}
// 转换课程数据格式
function transformItem(course: CourseItem, type: CourseType): CourseItem & CourseCardUIType {
  const { contentType, bizProdCount, learnStartTime, learnEndTime, taskSchedule, voteEndTime, voteStartTime, formalEndTime, mainType } =
    course
  let currentTime = moment(AjaxBasics.serviceDate.utcOffset(+8).valueOf())
  let btnText: string = ''
  let mainText: string = ''
  let processCount: number = taskSchedule ?? 0
  let unit: string = getUnit(type)
  let addBizProdCount: number = bizProdCount ?? 0
  let isOnlyText: boolean = true

  // 获取课程按钮文案
  if (type === EnumProductTypeQuery.Exhibition) {
    if (currentTime.isBefore(voteStartTime)) {
      btnText = '去备展'
    }
    btnText = '去观展'
  } else {
    btnText = '去学习'
  }

  // 课程的进行状态 - (系列课，专题课，教练日课)
  if (
    type === EnumProductTypeQuery.Course ||
    type === EnumProductTypeQuery.SpecialCourse ||
    type === EnumProductTypeQuery.DayCourse ||
    type === EnumProductTypeQuery.SelfStudy
  ) {
    //当前时间小于学习开始时间,未开课
    if (currentTime.isBefore(learnStartTime)) {
      mainText = '即将开课'
    }
    //进行中
    else if (currentTime.isAfter(learnStartTime) && currentTime.isBefore(learnEndTime)) {
      isOnlyText = false
    }
    //已结课
    else {
      mainText = '已结课'
    }
  } else {
    addBizProdCount += 2
    if (currentTime.isAfter(learnEndTime)) {
      mainText = '已结课'
      processCount += 2
    } else if (mainType === 1 || mainType === 2) {
      mainText = '选择临摹习作'
      isOnlyText = false
    } else if (mainType === 3) {
      mainText = '练习习作提交'
      processCount += 1
    } else if (mainType === 4) {
      mainText = '正式习作提交'
      processCount += 2
    } else if (mainType === 5) {
      mainText = currentTime.isAfter(formalEndTime) ? '备展结束' : '正式习作提交'
      processCount += 2
    }
  }

  return {
    ...course,
    type,
    mainText,
    processCount: processCount === 0 ? 1 : processCount,
    unit,
    bizProdCount: addBizProdCount,
    contentTypeText: getContentTypeText(contentType),
    btnText,
    isOnlyText
  }
}
// 获取进度单位
function getUnit(type: CourseType) {
  switch (type) {
    case EnumProductTypeQuery.Course:
      return EnumProductUnit.LiveCourseCountUnit
    case EnumProductTypeQuery.DayCourse:
      return EnumProductUnit.DayCourseCountUnit
    case EnumProductTypeQuery.Exhibition:
      return EnumProductUnit.ExhibitonCourseCountUnit
    default:
      return EnumProductUnit.LiveCourseCountUnit
  }
}
// 获取课程类型
function getContentTypeText(contentType: EnumContentType) {
  // 1 书法课，2读书课，3写作课，4养生课，5国画课，6实物商品，7书画课，8美育
  switch (contentType) {
    case EnumContentType.Painting:
      return EnumContentTypeText.Painting
    case EnumContentType.Calligraphy:
      return EnumContentTypeText.Calligraphy
    case EnumContentType.CalligraphyAndReading:
      return EnumContentTypeText.CalligraphyAndReading
    case EnumContentType.Health:
      return EnumContentTypeText.Health
    case EnumContentType.Physical:
      return EnumContentTypeText.Physical
    case EnumContentType.Reading:
      return EnumContentTypeText.Reading
    case EnumContentType.Writing:
      return EnumContentTypeText.Writing
    case EnumContentType.AestheticEducation:
      return EnumContentTypeText.AestheticEducation
    default:
      return EnumContentTypeText.Calligraphy
  }
}
